
import { useEffect, useState } from "react";
import {
  collection,
  query,
  onSnapshot,
  where,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase";

export default function useNotifications(userId, userRole) {
  const [notifications, setNotifications] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!userId || !userRole) return;
    if (userRole !== "admin" && userRole !== "director") return;

    const notifQuery = query(
      collection(db, "notifications"),
      where("targets", "array-contains", userRole),
      orderBy("created_at", "desc")
    );

    const readQuery = query(
      collection(db, "notifications_read"),
      where("user_id", "==", userId)
    );

    // local cache of read status
    let readMap = {};

    // Firestore listeners
    const unsubRead = onSnapshot(readQuery, (snap) => {
      const temp = {};
      snap.forEach((doc) => {
        temp[doc.data().notif_id] = doc.data().read_at;
      });
      readMap = temp; // replace old map
      // After read changes, update notification read state
      setNotifications((prev) =>
        prev.map((n) => ({
          ...n,
          isRead: Boolean(readMap[n.id]),
          readAt: readMap[n.id] || null,
        }))
      );
    });

    const unsubNotif = onSnapshot(notifQuery, (snap) => {
      const list = snap.docs.map((doc) => {
        const data = doc.data();
        return {
          id: doc.id,
          ...data,
          created_at: data.created_at?.toDate?.()
            ? data.created_at.toDate()
            : null,
          isRead: Boolean(readMap[doc.id]),
          readAt: readMap[doc.id] || null,
        };
      });

      setNotifications(list);
      setIsLoaded(true);
    });

    return () => {
      unsubNotif();
      unsubRead();
    };
  }, [userId, userRole]);

  return { notifications, isLoaded };
}
